require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-barcampes-sevilla-2012.json") })
        }
      }, "path---blog-barcampes-sevilla-2012");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-barcampes-sevilla-2012!./.cache/json/blog-barcampes-sevilla-2012.json
// module id = 255
// module chunks = 231608221292675